export const getActionFailureMessage = (payload) => {
  if (!payload || typeof payload !== 'object') {
    return null;
  }

  const candidateOutputs = [payload, payload.output, payload.output?.code_execution_result];
  for (const candidate of candidateOutputs) {
    if (candidate && typeof candidate === 'object' && candidate.success === false) {
      return candidate.message || candidate.error_message || 'Action invocation failed.';
    }
  }

  const orchestrationDeliveries = Array.isArray(payload.orchestration_deliveries)
    ? payload.orchestration_deliveries
    : [];
  const failedDelivery = orchestrationDeliveries.find((delivery) =>
    delivery && typeof delivery === 'object' && (
      delivery.success === false ||
      delivery.status === 'failed' ||
      delivery.error
    )
  );

  if (failedDelivery) {
    return (
      failedDelivery.error_message ||
      failedDelivery.message ||
      'Triggered orchestration failed.'
    );
  }

  return null;
};
